import React, { useState, useContext, ComponentType, FC, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Section from '../main/Section';
import LocalizationContext from '../../contexts/LocalizationContext';

export interface ISectionDetails {
    icon: FC<{ className: string }>;
    title?: string;
    sectionTitleString?: string;
    description?: string;
    descriptionIsHtml?: boolean;
}

export interface SectionProps {
    componentProps?: any;
    isCompleted?: boolean;
    autoClose?: boolean;
    isStaticOverwritten?: boolean;
    customSectionTitle?: string;
    [x: string]: any;
}

const useStyles = makeStyles({
    section: {
        margin: '10px 0',
    },
    collapsedSection: {
        '& > *': {
            display: 'none',
        },
    },
});

const inSection = (
    Component: ComponentType<any>,
    { icon, title, sectionTitleString, description, descriptionIsHtml }: ISectionDetails,
    isStatic: boolean = false,
    enableHelp: boolean = false
) => {
    return (props: SectionProps) => {
        const classes = useStyles();
        const { componentProps, isCompleted, isStaticOverwritten, customSectionTitle, autoClose, ...sectionProps } = props;
        const [lastAutoClose, setLastAutoClose] = useState<boolean>(autoClose || false);
        const [opened, setOpened] = useState(true);
        const localization = useContext(LocalizationContext);
        const titleText: string = customSectionTitle
            ? localization.strings.sections[customSectionTitle]
            : sectionTitleString
            ? localization.strings.sections[sectionTitleString]
            : title ?? '';

        useEffect(() => {
            if (!lastAutoClose && autoClose) {
                setLastAutoClose(autoClose);
            }
        }, [lastAutoClose, autoClose, setLastAutoClose]);

        if (isStatic && isStaticOverwritten !== true)
            return (
                <Section
                    enableHelp={enableHelp}
                    className={classes.section}
                    isStatic={isStatic}
                    icon={icon}
                    title={titleText}
                    description={description}
                    isDescriptionHtml={descriptionIsHtml}
                    titleKey={sectionTitleString ?? ''}
                    {...sectionProps}>
                    <Component {...{ ...componentProps, sectionTitleString }} />
                </Section>
            );
        else
            return (
                <Section
                    enableHelp={enableHelp}
                    className={classes.section}
                    icon={icon}
                    title={titleText}
                    titleKey={sectionTitleString ?? ''}
                    {...sectionProps}
                    isDescriptionHtml={descriptionIsHtml}
                    description={description}
                    isCompleted={isCompleted}
                    autoClose={autoClose !== undefined && autoClose !== lastAutoClose}
                    onToggle={(state: boolean) => setOpened(state)}>
                    <div className={opened ? 'collapsible-wrapper' : `collapsible-wrapper collapsed`}>
                        <div className={`collapsible ${opened ? '' : classes.collapsedSection}`} style={{ marginTop: '20px' }}>
                            <Component {...{ ...componentProps, sectionTitleString }} />
                        </div>
                    </div>
                </Section>
            );
    };
};

export default inSection;
